// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6d7f1d3c","839":"ff3f2f10"}[chunkId] + ".chunk.js";
};